var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-type-02 mt25 mb30" }, [
    _c("a", { staticClass: "save-button review fwB fade" }, [
      _c("p", [
        _c("img", {
          staticClass: "heart",
          attrs: { src: _vm.userCommonImageUrlForPc + "/icon_heart.png" },
        }),
        _vm._v("気になる\n    "),
      ]),
    ]),
    _vm._v(" "),
    _vm.isSimple && !_vm.isOriginalEntryForm
      ? _c(
          "a",
          {
            staticClass: "simple-entry-button fwB fade",
            attrs: { "data-test": "simple" },
          },
          [
            _c("p", [
              _c("img", {
                attrs: { src: _vm.userCommonImageUrlForPc + "/icon_pr.png" },
              }),
              _vm._v("\n      シンプル応募\n    "),
            ]),
          ]
        )
      : _c(
          "a",
          {
            staticClass: "entry-button fwB fade",
            attrs: { "data-test": "entry" },
          },
          [_c("p", [_vm._v("\n      応募する\n    ")])]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }